<section class="py-5">
  <div class="container pricing">
    <div class="row">
      <div class="pricing-header mb-4 p-3 pb-md-4 mx-auto text-center">
        <h1 class="display-4 fw-bold mb-3 text-body-emphasis">Pick your plan</h1>
        <p class="fs-5 text-secondary">
          Choose a plan that fits your creative needs — download beautiful illustrations with ease and power your
          projects with premium assets.
        </p>
      </div>
    </div>

    <div class="row row-cols-1 row-cols-md-2 mb-5 ">
      <div class="col">
        <div class="card mb-5 rounded-4">
          <div class="card-header pt-4 pb-0">
            <h2 class="my-0 mb-2 fw-bold">Free</h2>
            <p class="text-secondary">Get PNG downloads for personal and non-commercial use.</p>
          </div>
          <div class="card-body">
            <h1 class="card-title mb-4 pricing-card-title">
              &#8377; 0<small class="text-body-secondary fw-light">/mo</small>
            </h1>
            <ul class="list-unstyled mt-3 mb-2">
              <li><i class="fa-solid fa-check"></i> &nbsp; Limited downloads</li> <br>
              <li><i class="fa-solid fa-check"></i> &nbsp; No Commercial Use</li> <br>
              <li><i class="fa-solid fa-check"></i> &nbsp; Download PNG for Illustrations</li> <br>
               <li><i class="fa-solid fa-check"></i> &nbsp; Download AI Images <span class="badge-ai">New</span></li> <br>
              <!-- <li><i class="fa-solid fa-check"></i> &nbsp; No Custom illustration requests</li> <br> -->
               <li><i class="fa-solid fa-check"></i> &nbsp; Allow Custom illustration requests</li> <br>
              <li><i class="fa-solid fa-check"></i> &nbsp; Community Email</li>
            </ul> <br> <br>
            <a *ngIf="!user" routerLink="/signup" class="w-100 btn btn-lg btn-outline-black rounded-3">
              Get Started
            </a>
            <button *ngIf="user" disabled type="button" class="mb-1 w-100 btn btn-lg btn-outline-black rounded-3">
              3 Daily downloads
            </button>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card mb-4 rounded-4">
          <div class="card-header  pt-4 pb-0">
            <h2 class="my-0 mb-2 fw-bold">Pro</h2>
            <p class="text-secondary">Access all formats and unlock full commercial rights.</p>
          </div>
          <div class="card-body">
            <p><span class="text-muted original-price custom-strike">₹499</span>  </p>
            <h1 class="card-title mt-2 pricing-card-title d-flex align-items-center gap-2">
             <span class="offer-price">&#8377; {{ price || 0
              }}<small class="text-body-secondary fw-light">/mo</small></span>
             <span class="badge-new">Up to 80% OFF</span>
            </h1>
            <ul class="list-unstyled mt-3 mb-4">
              <li><i class="fa-solid fa-check"></i> &nbsp; Unlimited downloads</li> <br>
              <li><i class="fa-solid fa-check"></i> &nbsp; Allow commercial Use</li> <br>
              <li><i class="fa-solid fa-check"></i> &nbsp; Download PNG, SVG, EPS, AI</li> <br>
                             <li><i class="fa-solid fa-check"></i> &nbsp; Download AI Images <span class="badge-ai">New</span></li> <br>
              <li><i class="fa-solid fa-check"></i> &nbsp; Allow Custom illustration requests</li> <br>
              <li><i class="fa-solid fa-check"></i> &nbsp; Priority Email Support</li>
            </ul>
            <button type="button" class="w-100 btn btn-lg btn-ib-primary rounded-3" (click)="updateUserToSubscribed()">
              Get Pro
            </button>
          </div>
        </div>
      </div>
    </div>

    <h3 class="display-6 fw-bold text-center mb-4">Compare plans</h3>

    <div class="table-responsive mb-5">
      <table class="table text-center">
        <thead>
          <tr>
            <th style="width: 34%"></th>
            <th style="width: 22%">Free</th>
            <th style="width: 22%">Pro</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row" class="text-start">Daily Download Limit</th>
            <td>3 downloads/day</td>
            <td>Unlimited</td>
          </tr>
          <tr>
            <th scope="row" class="text-start">Commercial Use License</th>
            <td>No</td>
            <td>Yes</td>
          </tr>
        </tbody>

        <tbody>
          <tr>
            <th scope="row" class="text-start">Download Formats</th>
            <td>PNG only</td>
            <td>PNG, SVG, EPS, AI,</td>
          </tr>
          <tr>
            <th scope="row" class="text-start">Custom illustration requests</th>
            <td>No</td>
            <td>Yes</td>
          </tr>
          <tr>
            <th scope="row" class="text-start">Support</th>
            <td>Community Email</td>
            <td>Priority Email Support</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h3 class="display-6 fw-bold text-center mb-4">Frequently Asked Questions</h3>

    <div class="accordion mb-5" id="accordionExample">
      <div class="accordion-item mb-4">
        <h2 class="accordion-header">
          <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
            What’s included in the Pro plan?
          </button>
        </h2>
        <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-secondary">
            With the Pro plan, you get unlimited downloads, access to all illustrations, and new illustrations added
            weekly.
          </div>
        </div>
      </div>
      <div class="accordion-item mb-3">
        <h2 class="accordion-header">
          <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
            What do I get with the free plan?
          </button>
        </h2>
        <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-secondary">
            You can download up to 3 illustrations per day for free. It’s a great way to explore our library before
            upgrading.
          </div>
        </div>
      </div>
      <div class="accordion-item mb-3">
        <h2 class="accordion-header">
          <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
            Can I use Free plan illustrations for commercial projects?
          </button>
        </h2>
        <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-secondary">
            Yes, but only if you credit Illusbook (e.g., “Designed by Illusbook”). Attribution is required for any
            commercial use on the Free plan.
          </div>
        </div>
      </div>
      <div class="accordion-item mb-3">
        <h2 class="accordion-header">
          <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
            Do I need to give attribution with the Pro plan?
          </button>
        </h2>
        <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-secondary">
            No. Attribution is only required on the Free plan. Pro users are not required to credit Illusbook.
          </div>
        </div>
      </div>

      <div class="accordion-item mb-3">
        <h2 class="accordion-header">
          <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
            What if I exceed the free download limit?
          </button>
        </h2>
        <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-secondary">
            If you reach the daily limit on the free plan, you’ll need to wait until the next day or upgrade to the Pro
            plan for unlimited access.
          </div>
        </div>
      </div>

      <div class="accordion-item mb-3">
        <h2 class="accordion-header">
          <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
            Will new illustrations be added regularly?
          </button>
        </h2>
        <div id="collapseSix" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-secondary">
            Yes. We add fresh illustrations every week to keep your designs updated and visually rich.
          </div>
        </div>
      </div>

      <div class="accordion-item mb-3">
        <h2 class="accordion-header">
          <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
            Can I request custom illustrations?
          </button>
        </h2>
        <div id="collapseSeven" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-secondary">
            Only Pro plan users can request custom illustrations.
          </div>
        </div>
      </div>

      <div class="accordion-item mb-3">
        <h2 class="accordion-header">
          <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
            Can I modify the illustrations?
          </button>
        </h2>
        <div id="collapseEight" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-secondary">
            Absolutely! You can customize the illustrations to fit your project needs including colors, sizes, and
            compositions.
          </div>
        </div>
      </div>

      <div class="accordion-item mb-3">
        <h2 class="accordion-header">
          <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
            What payment methods do you accept?
          </button>
        </h2>
        <div id="collapseNine" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-secondary">
            We support all major credit/debit cards, UPI, and Razorpay for secure payments.
          </div>
        </div>
      </div>

      <div class="accordion-item mb-3">
        <h2 class="accordion-header">
          <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
            What if I have issues with downloading or accessing illustrations?
          </button>
        </h2>
        <div id="collapseTen" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-secondary">
            You can reach out to our support team anytime through our contact page or email — we’re happy to help!
          </div>
        </div>
      </div>

    </div>


    <div class="py-5">
      <h3 class="display-6 fw-bold text-center mb-4">We're Here to Help!</h3>
      <p class="text-center mb-5 text-secondary">We know committing to a Pro plan is a big step and we want you to
        feel confident about it. If you have any questions, or something’s not covered in our FAQ, don’t hesitate to
        reach out. We’re happy to assist you.</p>

      <div class="text-center">
        <div class="text-left justify-content-start">
          <a routerLink="/support" class="btn btn-ib-black rounded-3 fw-bold mb-4">Send us a message</a>
          <p class="text-secondary">We typically respond within a few hours quick, clear, and helpful.</p>
        </div>
      </div>
    </div>
  </div>

</section>